import { Label } from "components/generic";
import styled, { css } from "styled-components/macro";

export const NotVerification = styled(Label) <{
  state: "verifying" | "verified" | "unverified" | "failed" | "experienced";
}>`
  position: relative;
  ${(props) =>
    (props.state === "unverified" || props.state === "failed") &&
    css`
      color: ${(props) => props.theme.colors.place};
      background-color: ${(props) => props.theme.colors.thirdly};
    `};
  ${(props) =>
    (props.state === "verified" || props.state === "experienced") &&
    css`
      align-self: center;
      margin: 0.2rem;
      color: ${(props) => props.theme.colors.text};
      background-color: #e3edff;
    `};
  ${(props) =>
    props.state === "verifying" &&
    css`
      color: ${(props) => props.theme.colors.thirdly};
      background-color: ${(props) => props.theme.colors.secondary};
    `};
  padding: 0.2em 0.4em;
  text-align: center;
  cursor: pointer;
  & > label {
    position: absolute;
    bottom: calc(100% + 4px);
    right: 0;
    display: none;
    max-width: 400px;
    transition: 0.7s;
    font-size: 14px;
  }
  &:hover {
    & > label {
      display: block;
    }
  }
`;
